<template>
  <header class="header" :class="{ 'scrolled': isScrolled || isHovered, 'expanded': showDropdown || showPlatformDropdown }" @mouseenter="isHovered = true" @mouseleave="handleHeaderLeave">
    <div class="container">
      <div class="header-content">
        <div class="logo">
          <img
            v-if="isScrolled || isHovered"
            src="/纪煜科技-透明.png"
            alt="纪煜科技"
            class="logo-img"
          />
          <template v-else>
            <h1>纪煜科技</h1>
            <p class="logo-subtitle">NINGBO JIYU TECHNOLOGY</p>
          </template>
        </div>
        <nav class="nav">
          <ul class="nav-list">
            <li><a href="#" class="nav-link" :class="{ 'active': activeSection === 'home' }" @click.prevent="handleNavClick($event, 'home')">首页</a></li>
            <li><a href="#" class="nav-link" :class="{ 'active': activeSection === 'advantages' }" @click.prevent="handleNavClick($event, 'advantages')">核心优势</a></li>

            <!-- 技术平台 dropdown -->
            <li class="dropdown-container" @mouseenter="showPlatformDropdown = true; showDropdown = false">
              <a href="#" class="nav-link" :class="{ 'active': activeSection === 'platform' }" @click.prevent="handleNavClick($event, 'platform')">
                技术平台
              </a>
            </li>

            <!-- 解决方案 dropdown -->
            <li class="dropdown-container" @mouseenter="showDropdown = true; showPlatformDropdown = false">
              <a href="#" class="nav-link" :class="{ 'active': activeSection === 'solutions' }" @click.prevent="handleNavClick($event, 'solutions')">
                解决方案
              </a>
            </li>

            <li><a href="#" class="nav-link" :class="{ 'active': activeSection === 'timeline' }" @click.prevent="handleNavClick($event, 'timeline')">发展历程</a></li>
            <li><a href="#" class="nav-link" :class="{ 'active': activeSection === 'contact' }" @click.prevent="handleNavClick($event, 'contact')">联系我们</a></li>
          </ul>
        </nav>
        <div class="mobile-menu-btn" @click="toggleMobileMenu">
          <i class="fas fa-bars"></i>
        </div>
      </div>

      <!-- 技术平台子菜单 -->
      <div class="submenu-panel" v-if="showPlatformDropdown" @mouseenter="showPlatformDropdown = true">
        <div class="container">
          <div class="submenu-content">
            <div class="submenu-section">
              <h3>技术平台</h3>
              <div class="submenu-links">
                <router-link to="/llm" @click="closeSubmenu" class="submenu-item">
                  <div class="submenu-item-content">
                    <i class="fas fa-brain"></i>
                    <div>
                      <span class="submenu-title">大模型能力</span>
                      <span class="submenu-desc">先进的 AI 大模型技术与应用</span>
                    </div>
                  </div>
                </router-link>
                <router-link to="/data-platform" @click="closeSubmenu" class="submenu-item">
                  <div class="submenu-item-content">
                    <i class="fas fa-database"></i>
                    <div>
                      <span class="submenu-title">数据中台体系</span>
                      <span class="submenu-desc">企业级数据管理解决方案</span>
                    </div>
                  </div>
                </router-link>
                <router-link to="/lowcode" @click="closeSubmenu" class="submenu-item">
                  <div class="submenu-item-content">
                    <i class="fas fa-code"></i>
                    <div>
                      <span class="submenu-title">可视化低代码平台</span>
                      <span class="submenu-desc">快速构建企业应用</span>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 解决方案子菜单 -->
      <div class="submenu-panel" v-if="showDropdown" @mouseenter="showDropdown = true">
        <div class="container">
          <div class="submenu-content">
            <div class="submenu-section">
              <h3>解决方案</h3>
              <div class="submenu-links">
                <router-link to="/ai" @click="closeSubmenu" class="submenu-item">
                  <div class="submenu-item-content">
                    <i class="fas fa-robot"></i>
                    <div>
                      <span class="submenu-title">AI 智能应用</span>
                      <span class="submenu-desc">智能化业务解决方案</span>
                    </div>
                  </div>
                </router-link>
                <router-link to="/data-service" @click="closeSubmenu" class="submenu-item">
                  <div class="submenu-item-content">
                    <i class="fas fa-chart-line"></i>
                    <div>
                      <span class="submenu-title">数据服务</span>
                      <span class="submenu-desc">全方位数据服务支持</span>
                    </div>
                  </div>
                </router-link>
                <router-link to="/tech-consult" @click="closeSubmenu" class="submenu-item">
                  <div class="submenu-item-content">
                    <i class="fas fa-lightbulb"></i>
                    <div>
                      <span class="submenu-title">技术咨询</span>
                      <span class="submenu-desc">专业技术咨询服务</span>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div class="mobile-nav" :class="{ 'active': mobileMenuOpen }">
        <ul>
          <li><a href="#" :class="{ 'active': activeSection === 'home' }" @click.prevent="scrollToSectionAndClose('home')">首页</a></li>
          <li><a href="#" :class="{ 'active': activeSection === 'advantages' }" @click.prevent="scrollToSectionAndClose('advantages')">核心优势</a></li>
          <li class="mobile-dropdown">
            <div class="mobile-dropdown-toggle" @click="togglePlatformDropdown">
              <span>技术平台</span>
              <i class="fas fa-chevron-down" :class="{ 'rotate': showPlatformMobileDropdown }"></i>
            </div>
            <ul class="mobile-dropdown-menu" :class="{ 'show': showPlatformMobileDropdown }">
              <li><router-link to="/llm" @click="closeMobileMenu">大模型能力</router-link></li>
              <li><router-link to="/data-platform" @click="closeMobileMenu">数据中台体系</router-link></li>
              <li><router-link to="/lowcode" @click="closeMobileMenu">可视化低代码平台</router-link></li>
            </ul>
          </li>
          <li class="mobile-dropdown">
            <div class="mobile-dropdown-toggle" @click="toggleSolutionsDropdown">
              <span>解决方案</span>
              <i class="fas fa-chevron-down" :class="{ 'rotate': showSolutionsMobileDropdown }"></i>
            </div>
            <ul class="mobile-dropdown-menu" :class="{ 'show': showSolutionsMobileDropdown }">
              <li><router-link to="/ai" @click="closeMobileMenu">AI 智能应用</router-link></li>
              <li><router-link to="/data-service" @click="closeMobileMenu">数据服务</router-link></li>
              <li><router-link to="/tech-consult" @click="closeMobileMenu">技术咨询</router-link></li>
            </ul>
          </li>
          <li><a href="#" :class="{ 'active': activeSection === 'timeline' }" @click.prevent="scrollToSectionAndClose('timeline')">发展历程</a></li>
          <li><a href="#" :class="{ 'active': activeSection === 'contact' }" @click.prevent="scrollToSectionAndClose('contact')">联系我们</a></li>
        </ul>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'Header',
  data() {
    return {
      mobileMenuOpen: false,
      isScrolled: false,
      isHovered: false,
      activeSection: 'home',
      showDropdown: false,
      showPlatformDropdown: false,
      showPlatformMobileDropdown: false,
      showSolutionsMobileDropdown: false
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    // 初始化时设置正确的激活项和导航栏状态
    this.$nextTick(() => {
      this.updateActiveSection();
      this.checkRoute();
      this.updateActiveSectionFromRoute();
    });
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  watch: {
    '$route'() {
      this.checkRoute();
      this.updateActiveSectionFromRoute();
    }
  },
  methods: {
    handleHeaderLeave() {
      this.isHovered = false;
      // 当鼠标离开导航栏时，隐藏所有子菜单
      this.showDropdown = false;
      this.showPlatformDropdown = false;
    },
    closeSubmenu() {
      this.showDropdown = false;
      this.showPlatformDropdown = false;
    },
    checkRoute() {
      // 如果不是首页，导航栏默认不透明
      this.isScrolled = this.$route.path !== '/';
      // 根据路由更新激活的导航项
      this.updateActiveSectionFromRoute();
    },
    handleScroll() {
      // 当页面向下滚动超过 50px 时，添加 scrolled 类
      this.isScrolled = this.$route.path !== '/' || window.scrollY > 50;
      // 更新激活的导航项
      this.updateActiveSection();
    },
    updateActiveSection() {
      const sections = ['home', 'advantages', 'platform', 'solutions', 'timeline', 'contact'];
      const scrollPosition = window.scrollY + 100; // 减少偏移量以更准确判断
      
      // 如果在页面顶部，直接激活 home
      if (window.scrollY === 0) {
        this.activeSection = 'home';
        return;
      }
      
      // 找到当前视口顶部对应的section
      let currentSection = 'home';
      for (let i = 0; i < sections.length; i++) {
        const section = document.getElementById(sections[i]);
        if (section) {
          const sectionTop = section.offsetTop - 80; // 调整头部高度偏移
          const sectionBottom = sectionTop + section.offsetHeight;
          
          if (scrollPosition >= sectionTop && scrollPosition <= sectionBottom) {
            currentSection = sections[i];
            break;
          }
        }
      }
      
      // 如果滚动位置超过了最后一个section，则激活最后一个
      const lastSection = document.getElementById('contact');
      if (lastSection && scrollPosition > lastSection.offsetTop + lastSection.offsetHeight / 2) {
        currentSection = 'contact';
      }
      
      this.activeSection = currentSection;
    },
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen;
    },
    closeMobileMenu() {
      this.mobileMenuOpen = false;
      this.showPlatformMobileDropdown = false;
      this.showSolutionsMobileDropdown = false;
    },
    togglePlatformDropdown() {
      this.showPlatformMobileDropdown = !this.showPlatformMobileDropdown;
      this.showSolutionsMobileDropdown = false;
    },
    toggleSolutionsDropdown() {
      this.showSolutionsMobileDropdown = !this.showSolutionsMobileDropdown;
      this.showPlatformMobileDropdown = false;
    },
    handleNavClick(event, id) {
      const currentPath = this.$route.path;

      if (currentPath === '/') {
        // 如果在首页，直接滚动到对应区域
        this.scrollToSection(id);
      } else {
        // 如果在子页面，先跳转到首页，然后滚动到对应区域
        this.$router.push('/').then(() => {
          setTimeout(() => {
            this.scrollToSection(id);
          }, 300); // 增加延迟，确保页面已经加载完成
        });
      }
    },
    scrollToSection(id) {
      const element = document.getElementById(id);
      if (element) {
        const rect = element.getBoundingClientRect();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const offsetTop = rect.top + scrollTop - 80; // 考虑固定头部的高度

        window.scrollTo({
          top: offsetTop,
          behavior: 'smooth'
        });
        // 手动设置激活项
        this.activeSection = id;
      }
    },
    scrollToSectionAndClose(id) {
      const currentPath = this.$route.path;

      if (currentPath === '/') {
        // 如果在首页，直接滚动到对应区域
        this.scrollToSection(id);
        this.closeMobileMenu();
      } else {
        // 如果在子页面，先跳转到首页，然后滚动到对应区域
        this.closeMobileMenu();
        this.$router.push('/').then(() => {
          setTimeout(() => {
            this.scrollToSection(id);
          }, 300);
        });
      }
    },
    updateActiveSectionFromRoute() {
      const path = this.$route.path;

      // 子页面路由映射
      const routeToSection = {
        '/llm': 'platform',
        '/data-platform': 'platform',
        '/lowcode': 'platform',
        '/ai': 'solutions',
        '/data-service': 'solutions',
        '/tech-consult': 'solutions'
      };

      if (routeToSection[path]) {
        this.activeSection = routeToSection[path];
      }
    }
  }
}
</script>

<style scoped>
.header {
  background-color: transparent;
  box-shadow: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  transition: background-color 0.3s ease, box-shadow 0.3s ease;
  height: auto;
  min-height: 80px;
}

.header.scrolled {
  background-color: var(--white);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.header.expanded {
  background-color: var(--white);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
}

.logo h1 {
  font-size: 1.5rem;
  color: var(--white); /* 修改：默认状态下文字颜色改为白色 */
  font-weight: 700;
  line-height: 1.2;
}

.logo-img {
  max-height: 55px;
  width: auto;
  display: block;
}

.header.scrolled .logo h1 {
  color: var(--primary-blue);
}

.logo-subtitle {
  font-size: 0.8rem;
  color: var(--white); /* 修改：默认状态下副标题颜色改为白色 */
  margin-top: 5px;
}

.header.scrolled .logo-subtitle {
  color: var(--text-light);
}

.nav-list {
  display: flex;
  list-style: none;
}

.nav-list li {
  margin-left: 40px; /* 修改：导航项间隔从30px增加到40px */
  display: flex;
  align-items: center;
}

/* 下拉菜单样式 */
.dropdown-container {
  position: relative;
}

/* 子菜单面板 */
.submenu-panel {
  background-color: var(--white);
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  animation: slideDown 0.3s ease;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.submenu-content {
  padding: 30px 0;
}

.submenu-section h3 {
  color: var(--primary-blue);
  font-size: 1.2rem;
  margin-bottom: 20px;
  font-weight: 700;
}

.submenu-links {
  display: flex;
  gap: 20px;
}

.submenu-item {
  flex: 1;
  text-decoration: none;
  color: inherit;
  display: block;
  padding: 20px;
  border-radius: 8px;
  transition: all 0.3s ease;
  background-color: var(--light-gray);
}

.submenu-item:hover {
  background-color: var(--light-blue);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.submenu-item-content {
  display: flex;
  align-items: center;
  gap: 15px;
}

.submenu-item-content i {
  font-size: 1.8rem;
  color: var(--primary-blue);
  width: 40px;
  text-align: center;
}

.submenu-item-content > div {
  flex: 1;
}

.submenu-title {
  display: block;
  font-size: 1rem;
  font-weight: 600;
  color: var(--text-dark);
  margin-bottom: 5px;
}

.submenu-desc {
  display: block;
  font-size: 0.85rem;
  color: var(--text-light);
  line-height: 1.4;
}

.nav-link {
  text-decoration: none;
  color: var(--white);
  font-weight: 600;
  font-size: 1rem;
  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  position: relative;
  padding: 5px 0;
  cursor: pointer;
  display: inline-block;
  /* 添加未来感元素 */
  will-change: transform, opacity;
}

.header.scrolled .nav-link {
  color: var(--text-dark);
}

/* 删除:.nav-link:hover, .nav-link.active { */
/* 删除:  color: var(--white); */
/* 删除:} */

/* 删除:.header.scrolled .nav-link:hover, .header.scrolled .nav-link.active { */
/* 删除:  color: var(--primary-blue); */
/* 删除:} */

/* 新增未来感悬停效果 */
.nav-link::before {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 2px;
  background: linear-gradient(90deg, var(--accent-gold), var(--primary-blue));
  transition: width 0.3s ease;
  border-radius: 2px;
}

.nav-link:hover::before,
.nav-link.active::before {
  width: 100%;
}

.nav-link:hover,
.nav-link.active {
  color: var(--white);
  transform: translateY(-2px);
  text-shadow: 0 0 8px rgba(255, 255, 255, 0.5);
}

.header.scrolled .nav-link:hover,
.header.scrolled .nav-link.active {
  color: var(--primary-blue);
  transform: translateY(-2px);
  text-shadow: 0 0 8px rgba(26, 58, 143, 0.3);
}

.nav-link.active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 3px;
  background-color: var(--accent-gold);
  border-radius: 1.5px;
}

.mobile-menu-btn {
  display: none;
  font-size: 1.5rem;
  color: var(--white);
  cursor: pointer;
}

.header.scrolled .mobile-menu-btn {
  color: var(--primary-blue);
}

.mobile-nav {
  display: none;
  background-color: var(--white);
  padding: 20px;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
  border-top: 1px solid #eee;
}

.mobile-nav ul {
  list-style: none;
}

.mobile-nav li {
  margin-bottom: 15px;
}

.mobile-nav a {
  text-decoration: none;
  color: var(--text-dark);
  font-weight: 600;
  font-size: 1.1rem;
  display: block;
  padding: 10px 0;
  border-bottom: 1px solid #eee;
  cursor: pointer;
}

.mobile-nav a:hover {
  color: var(--primary-blue);
}

.mobile-dropdown {
  position: relative;
}

.mobile-dropdown-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0;
  cursor: pointer;
  color: var(--text-dark);
  font-weight: 600;
  font-size: 1.1rem;
  border-bottom: 1px solid #eee;
}

.mobile-dropdown-toggle:hover {
  color: var(--primary-blue);
}

.mobile-dropdown-toggle i {
  transition: transform 0.3s ease;
}

.mobile-dropdown-toggle i.rotate {
  transform: rotate(180deg);
}

.mobile-dropdown-menu {
  display: none;
  padding-left: 20px;
  margin-top: 10px;
}

.mobile-dropdown-menu.show {
  display: block;
}

.mobile-dropdown-menu li {
  margin-bottom: 10px;
}

.mobile-dropdown-menu a {
  font-size: 1rem;
  color: var(--text-light);
  padding: 8px 0;
  border: none;
}

@media (max-width: 992px) {
  .nav {
    display: none;
  }

  .mobile-menu-btn {
    display: block;
  }

  .mobile-nav.active {
    display: block;
  }

  .logo-img {
    max-height: 42px;
  }
}
</style>







